import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';
import type { ExactOnlineConnectionStatus, ExactOnlineDivision } from '@models/exact-online';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ExactOnlineService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/api/crm/exact-online`;

  getConnections(): Observable<ExactOnlineConnectionStatus[]> {
    return this.http.get<ExactOnlineConnectionStatus[]>(`${this.baseUrl}/connections`);
  }

  getAuthorizeUrl(locale: string): Observable<{ url: string }> {
    return this.http.get<{ url: string }>(`${this.baseUrl}/connections/${locale}/authorize-url`);
  }

  getDivisions(locale: string): Observable<ExactOnlineDivision[]> {
    return this.http.get<ExactOnlineDivision[]>(`${this.baseUrl}/connections/${locale}/divisions`);
  }

  setDivision(locale: string, divisionCode: string): Observable<ExactOnlineConnectionStatus> {
    return this.http.put<ExactOnlineConnectionStatus>(`${this.baseUrl}/connections/${locale}/division`, {
      divisionCode,
    });
  }

  disconnect(locale: string): Observable<ExactOnlineConnectionStatus> {
    return this.http.delete<ExactOnlineConnectionStatus>(`${this.baseUrl}/connections/${locale}`);
  }
}
